import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Route, withRouter } from "react-router-dom";

import { toggleSidebar, toggleSubMenu } from "../../actions/layout";
import {
  useExchangeToken,
  useExchangeTokenSimCertAuditExecution,
} from "../../actions/auth";
import { MENU_ITEMS, getAccessForRoles } from "../../config/menuAccess";

export function LeftSideBar(props) {
  const {
    role,
    toggleSubMenu,
    openSubMenu,
    push,
    openSidebar,
    toggleSidebar,
    user,
  } = props;

  function goTo(id, to, event) {
    event.preventDefault();
    const topMenu = MENU_ITEMS.find((x) => x.id === id);
    if (topMenu?.children) {
      toggleSubMenu(id);
    } else {
      toggleSidebar();
      push(to);
    }
  }
  const exchange = useExchangeToken({
    token: user?.access_token,
    userId: user?.id,
  });

  const exchangeSimCertAuditExecution = useExchangeTokenSimCertAuditExecution({
    token: user?.access_token,
    userId: user?.id,
  });

  const access = getAccessForRoles(role);

  return (
    <div
      id="left-sidebar"
      className={`left-sidebar ${
        props.openSidebar ? "sidebar-float-active" : "minified"
      }`}
    >
      {
        // <div className='sidebar-minified js-toggle-minified'>
        //   <i className='fa fa-exchange' onClick={props.toggleSidebar} />
        // </div>
      }
      <div className="sidebar-scroll">
        <nav className="main-nav">
          <ul className="main-menu">
            {MENU_ITEMS.map((x, i) => {
              if (access.includes(x.id) && !x.hidden) {
                return (
                  <Route
                    key={i}
                    path={x.url}
                    exact={!!x.exact}
                    children={(match) => (
                      <li className={match.match ? "active " : ""}>
                        {x.id == "advance-scheduling" ? (
                          <>
                            <div
                              className="advance-menu-hover"
                              onClick={exchange}
                              style={{
                                cursor: "pointer",
                                padding: "13px 0 13px 15px",
                                backgroundColor: "#144796",
                                color: "#fff",
                                borderTop: "1px solid #1a5dc6",
                              }}
                            >
                              <i className={x.icon} />
                              <span className="text">
                                {x.title}
                                {/* <span className='badge element-bg-color-blue'>New</span> */}
                              </span>
                            </div>
                          </>
                        ) : x.id == "audit-execution" ? (
                          <>
                            <div
                              className="advance-menu-hover"
                              onClick={exchangeSimCertAuditExecution}
                              style={{
                                cursor: "pointer",
                                padding: "13px 0 13px 15px",
                                backgroundColor: "#144796",
                                color: "#fff",
                                borderTop: "1px solid #1a5dc6",
                              }}
                            >
                              <i className={x.icon} />
                              <span className="text">
                                {x.title}
                                {/* <span className='badge element-bg-color-blue'>New</span> */}
                              </span>
                            </div>
                          </>
                        ) : (
                          <a
                            className={`js-sub-menu-toggle ${x.title}`}
                            onClick={(e) => goTo(x.id, x.url, e)}
                            href="#top"
                          >
                            <i className={x.icon} />
                            <span className="text">
                              {" "}
                              {x.title}
                              {/* <span className='badge element-bg-color-blue'>New</span> */}
                            </span>
                            {x.children && (
                              <>
                                {openSubMenu === x.id ? (
                                  <i className="toggle-icon fa fa-angle-down" />
                                ) : (
                                  <i className="toggle-icon fa fa-angle-left" />
                                )}
                              </>
                            )}
                          </a>
                        )}

                        {x.children && (
                          <ul
                            className={
                              openSubMenu === x.id && openSidebar
                                ? "sub-menu open"
                                : "sub-menu"
                            }
                          >
                            {x.children.map((y, j) => {
                              if (access.includes(y.id)) {
                                return (
                                  <Route
                                    key={j}
                                    path={y.url}
                                    exact
                                    children={(match) => (
                                      <li
                                        className={match.match ? "active " : ""}
                                      >
                                        <a
                                          className={
                                            "link-" +
                                            y.title
                                              .toLowerCase()
                                              .split(" ")
                                              .join("-")
                                          }
                                          to={y.url}
                                          onClick={(e) => goTo(null, y.url, e)}
                                          href="#top"
                                        >
                                          <span className="text">
                                            {y.title}
                                          </span>
                                        </a>
                                      </li>
                                    )}
                                  />
                                );
                              } else {
                                return "";
                              }
                            })}
                          </ul>
                        )}
                      </li>
                    )}
                  />
                );
              }
              return "";
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    role: state.auth.user.data.role,
    openSidebar: state.layout.openSidebar,
    openSubMenu: state.layout.openSubMenu,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleSidebar: () => dispatch(toggleSidebar()),
    toggleSubMenu: (menu) => dispatch(toggleSubMenu(menu)),
    push: (to) => dispatch(push(to)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeftSideBar),
);
